<template>
  <div class="pwa-userinfo">
    <!-- 헤더 -->
    <div class="pwa-header">
      <button class="back-btn" @click="goBack">
        <v-icon size="24" color="white">mdi-arrow-left</v-icon>
      </button>
      <h1 class="header-title">내 정보</h1>
      <div class="header-spacer"></div>
    </div>

    <!-- 메인 컨텐츠 -->
    <div class="pwa-content">
      <!-- 기본 정보 섹션 -->
      <div class="info-section">
        <h2 class="section-title">기본 정보</h2>
        <div class="info-item">
          <label class="info-label">아이디</label>
          <input
            v-model="userInfo.m_id"
            type="text"
            class="info-input"
            readonly
            :disabled="loading"
          />
        </div>
        <div class="info-item">
          <label class="info-label">장기요양기관기호</label>
          <input
            v-model="userInfo.m_longterm_code"
            type="text"
            class="info-input"
            readonly
            :disabled="loading"
          />
        </div>
        <div class="info-item">
          <label class="info-label">사용자명 <span class="required"></span></label>
          <input
            v-model="userInfo.m_user_name"
            type="text"
            class="info-input"
            placeholder="사용자명을 입력하세요"
            :disabled="loading"
            maxlength="20"
          />
        </div>
        <div class="info-item">
          <label class="info-label">기관명 <span class="required"></span></label>
          <input
            v-model="userInfo.m_sisul_name"
            type="text"
            class="info-input"
            placeholder="기관명을 입력하세요"
            :disabled="loading"
            maxlength="50"
          />
        </div>
      </div>

      <!-- 업체 정보 섹션 -->
      <div class="info-section">
        <h2 class="section-title">업체 정보</h2>
        <div class="info-item">
          <label class="info-label">사업형태</label>
          <input
            v-model="userInfo.m_biz_gubun"
            type="text"
            class="info-input"
            placeholder="사업형태를 입력하세요"
            :disabled="loading"
            maxlength="30"
          />
        </div>
        <div class="info-item">
          <label class="info-label">사업자등록번호</label>
          <input
            v-model="userInfo.m_biz_num"
            type="text"
            class="info-input"
            placeholder="123-45-67890"
            :disabled="loading"
            @input="(e: any) => (userInfo.m_biz_num = formatBizNum(e.target.value))"
            maxlength="12"
          />
        </div>
      </div>

      <!-- 연락처 정보 섹션 -->
      <div class="info-section">
        <h2 class="section-title">연락처 정보</h2>
        <div class="info-item">
          <label class="info-label">기관 전화번호</label>
          <div class="phone-input-group">
            <input
              v-model="userInfo.m_sisul_call_num1"
              type="text"
              class="info-input phone-input"
              placeholder="02"
              :disabled="loading"
              @input="(e: any) => (userInfo.m_sisul_call_num1 = numbersOnly(e.target.value).slice(0, 4))"
              maxlength="4"
            />
            <span class="phone-separator">-</span>
            <input
              v-model="userInfo.m_sisul_call_num2"
              type="text"
              class="info-input phone-input"
              placeholder="1234"
              :disabled="loading"
              @input="(e: any) => (userInfo.m_sisul_call_num2 = numbersOnly(e.target.value).slice(0, 4))"
              maxlength="4"
            />
            <span class="phone-separator">-</span>
            <input
              v-model="userInfo.m_sisul_call_num3"
              type="text"
              class="info-input phone-input"
              placeholder="5678"
              :disabled="loading"
              @input="(e: any) => (userInfo.m_sisul_call_num3 = numbersOnly(e.target.value).slice(0, 4))"
              maxlength="4"
            />
          </div>
        </div>
        <div class="info-item">
          <label class="info-label">대표자 번호</label>
          <div class="phone-input-group">
            <input
              v-model="userInfo.m_phone1"
              type="text"
              class="info-input phone-input"
              placeholder="010"
              :disabled="loading"
              @input="(e: any) => (userInfo.m_phone1 = numbersOnly(e.target.value).slice(0, 3))"
              maxlength="3"
            />
            <span class="phone-separator">-</span>
            <input
              v-model="userInfo.m_phone2"
              type="text"
              class="info-input phone-input"
              placeholder="1234"
              :disabled="loading"
              @input="(e: any) => (userInfo.m_phone2 = numbersOnly(e.target.value).slice(0, 4))"
              maxlength="4"
            />
            <span class="phone-separator">-</span>
            <input
              v-model="userInfo.m_phone3"
              type="text"
              class="info-input phone-input"
              placeholder="5678"
              :disabled="loading"
              @input="(e: any) => (userInfo.m_phone3 = numbersOnly(e.target.value).slice(0, 4))"
              maxlength="4"
            />
          </div>
        </div>
        <div class="info-item">
          <label class="info-label">이메일</label>
          <input
            v-model="userInfo.m_email"
            type="email"
            class="info-input"
            placeholder="이메일을 입력하세요"
            :disabled="loading"
            maxlength="100"
          />
        </div>
        <div class="info-item">
          <label class="info-label">팩스번호</label>
          <div class="phone-input-group">
            <input
              v-model="userInfo.m_fax1"
              type="text"
              class="info-input phone-input"
              placeholder="02"
              :disabled="loading"
              @input="(e: any) => (userInfo.m_fax1 = numbersOnly(e.target.value).slice(0, 4))"
              maxlength="4"
            />
            <span class="phone-separator">-</span>
            <input
              v-model="userInfo.m_fax2"
              type="text"
              class="info-input phone-input"
              placeholder="1234"
              :disabled="loading"
              @input="(e: any) => (userInfo.m_fax2 = numbersOnly(e.target.value).slice(0, 4))"
              maxlength="4"
            />
            <span class="phone-separator">-</span>
            <input
              v-model="userInfo.m_fax3"
              type="text"
              class="info-input phone-input"
              placeholder="5678"
              :disabled="loading"
              @input="(e: any) => (userInfo.m_fax3 = numbersOnly(e.target.value).slice(0, 4))"
              maxlength="4"
            />
          </div>
        </div>
      </div>

      <!-- 은행 정보 섹션 -->
      <div class="info-section">
        <h2 class="section-title">은행 정보</h2>
        <div class="info-item">
          <label class="info-label">은행명</label>
          <input
            v-model="userInfo.m_bank_name"
            type="text"
            class="info-input"
            placeholder="은행명을 입력하세요"
            :disabled="loading"
            maxlength="20"
          />
        </div>
        <div class="info-item">
          <label class="info-label">계좌번호</label>
          <input
            v-model="userInfo.m_bank_num"
            type="text"
            class="info-input"
            placeholder="계좌번호를 입력하세요"
            :disabled="loading"
            maxlength="50"
          />
        </div>
        <div class="info-item">
          <label class="info-label">예금주</label>
          <input
            v-model="userInfo.m_bank_owner"
            type="text"
            class="info-input"
            placeholder="예금주를 입력하세요"
            :disabled="loading"
            maxlength="45"
          />
        </div>
      </div>

      <!-- 주소 정보 섹션 -->
      <div class="info-section">
        <h2 class="section-title">주소 정보</h2>
        <div class="info-item">
          <label class="info-label">주소</label>
          <div class="address-input-group">
            <input
              v-model="userInfo.m_addr"
              type="text"
              class="info-input"
              placeholder="도로명 주소"
              :disabled="loading"
              readonly
              @click="openAddressModal"
            />
            <button
              type="button"
              class="address-btn"
              @click="openAddressModal"
              :disabled="loading"
            >
              검색
            </button>
          </div>
        </div>
        <div class="info-item">
          <label class="info-label">상세주소</label>
          <input
            v-model="userInfo.m_addr_detail"
            type="text"
            class="info-input"
            placeholder="상세주소를 입력해주세요"
            :disabled="loading"
            maxlength="100"
          />
        </div>
      </div>

      <!-- 버튼 섹션 -->
      <div class="button-section">
        <button
          class="save-btn"
          @click="updateUserInfo"
          :disabled="loading || !isFormValid"
        >
          <v-icon size="20" color="white" class="mr-2">mdi-content-save</v-icon>
          정보 수정
        </button>
        <button
          class="password-btn"
          @click="openPasswordModal"
          :disabled="loading"
        >
          <v-icon size="20" color="#1e3a8a" class="mr-2">mdi-lock-reset</v-icon>
          비밀번호 변경
        </button>
      </div>
    </div>

    <!-- 비밀번호 변경 모달 -->
    <v-dialog v-model="passwordDialog" max-width="90%" >
      <v-card rounded="lg">
        <v-card-title class="modal-title">
          <v-icon color="#1e3a8a" class="mr-2">mdi-lock-reset</v-icon>
          비밀번호 변경
        </v-card-title>
        <v-card-text class="modal-content">
          <div class="modal-field">
            <label class="modal-label">현재 비밀번호 <span class="required"></span></label>
            <div class="input-with-icon">
              <input
                v-model="passwordData.currentPassword"
                :type="showCurrentPassword ? 'text' : 'password'"
                class="modal-input"
                placeholder="현재 비밀번호를 입력하세요"
                :disabled="passwordLoading"
                maxlength="50"
              />
              <button
                type="button"
                class="password-toggle"
                @click="showCurrentPassword = !showCurrentPassword"
              >
                <v-icon size="18">{{ showCurrentPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
              </button>
            </div>
          </div>
          
          <div class="modal-field">
            <label class="modal-label">새 비밀번호 <span class="required"></span></label>
            <div class="input-with-icon">
              <input
                v-model="passwordData.newPassword"
                :type="showNewPassword ? 'text' : 'password'"
                class="modal-input"
                placeholder="새 비밀번호를 입력하세요"
                :disabled="passwordLoading"
                @input="validatePassword"
                maxlength="50"
              />
              <button
                type="button"
                class="password-toggle"
                @click="showNewPassword = !showNewPassword"
              >
                <v-icon size="18">{{ showNewPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
              </button>
            </div>
          </div>
          
          <div class="modal-field">
            <label class="modal-label">새 비밀번호 확인 <span class="required"></span></label>
            <div class="input-with-icon">
              <input
                v-model="passwordData.confirmNewPassword"
                :type="showConfirmNewPassword ? 'text' : 'password'"
                class="modal-input"
                placeholder="새 비밀번호를 다시 입력하세요"
                :disabled="passwordLoading"
                @input="validatePassword"
                maxlength="50"
              />
              <button
                type="button"
                class="password-toggle"
                @click="showConfirmNewPassword = !showConfirmNewPassword"
              >
                <v-icon size="18">{{ showConfirmNewPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
              </button>
            </div>
            <div v-if="passwordError" class="error-message">{{ passwordError }}</div>
          </div>
        </v-card-text>
        <v-card-actions class="modal-actions">
          <button class="cancel-btn" @click="closePasswordModal" :disabled="passwordLoading">
            취소
          </button>
          <button
            class="confirm-btn"
            @click="changePassword"
            :disabled="passwordLoading || !isPasswordValid"
          >
            변경하기
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 주소 검색 다이얼로그 -->
    <v-dialog v-model="addressDialog" max-width="90%" >
      <v-card rounded="lg">
        <v-card-title class="modal-title">주소 검색</v-card-title>
        <v-card-text style="height: 420px; position: relative;">
          <div v-if="addressLoading" class="loading-overlay">
            <v-progress-circular
              indeterminate
              color="#1e3a8a"
              size="48"
            ></v-progress-circular>
            <div class="loading-text">주소 검색을 불러오는 중...</div>
          </div>
          <div ref="postcodeContainer" style="width:100%; height:100%;" v-show="!addressLoading"></div>
        </v-card-text>
        <v-card-actions class="modal-actions">
          <button class="cancel-btn" @click="addressDialog = false" :disabled="addressLoading">
            닫기
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 로딩 컴포넌트 -->
    <LodingComponent :is-visible="loading || passwordLoading" :text="loadingText" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, nextTick, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';

const store = useStore();
const router = useRouter();

const API_BASE_URL = '/api';

const loading = ref(false);
const loadingText = ref('로딩 중...');
const passwordLoading = ref(false);
const snackbar = ref({ show: false, message: '', color: 'info' });
const addressDialog = ref(false);
const postcodeContainer = ref<HTMLDivElement | null>(null);
const addressLoading = ref(false);

// 비밀번호 변경 관련
const passwordDialog = ref(false);
const showCurrentPassword = ref(false);
const showNewPassword = ref(false);
const showConfirmNewPassword = ref(false);
const passwordError = ref('');

const passwordData = ref({
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: ''
});

let daumScriptLoading: Promise<void> | null = null;

// 사용자 정보
const userInfo = ref({
  m_idx: 0,
  m_id: '',
  m_sisul_code: '',
  m_longterm_code: '',
  m_pw: '',
  m_sisul_name: '',
  m_biz_gubun: '',
  m_biz_num: '',
  m_user_name: '',
  m_email: '',
  m_sisul_call_num1: '',
  m_sisul_call_num2: '',
  m_sisul_call_num3: '',
  m_phone1: '',
  m_phone2: '',
  m_phone3: '',
  m_fax1: '',
  m_fax2: '',
  m_fax3: '',
  m_bank_num: '',
  m_bank_name: '',
  m_bank_owner: '',
  m_addr: '',
  m_addr_detail: ''
});

// 폼 유효성 검사
const isFormValid = computed(() => {
  return userInfo.value.m_user_name && userInfo.value.m_sisul_name;
});

const isPasswordValid = computed(() => {
  return passwordData.value.currentPassword &&
         passwordData.value.newPassword &&
         passwordData.value.confirmNewPassword &&
         passwordData.value.newPassword === passwordData.value.confirmNewPassword &&
         passwordData.value.newPassword.length >= 6 &&
         !passwordError.value;
});

// 입력값 포맷터
const numbersOnly = (value: string) => value.replace(/[^\d]/g, '');

const formatPhone = (value: string) => {
  const digits = numbersOnly(value).slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,7)}-${digits.slice(7)}`;
};

const formatBizNum = (value: string) => {
  const digits = numbersOnly(value).slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,5)}-${digits.slice(5)}`;
};

// 비밀번호 유효성 검사
const validatePassword = () => {
  passwordError.value = '';
  
  if (passwordData.value.newPassword && passwordData.value.newPassword.length < 6) {
    passwordError.value = '비밀번호는 6자 이상이어야 합니다.';
    return;
  }
  
  if (passwordData.value.newPassword && passwordData.value.confirmNewPassword) {
    if (passwordData.value.newPassword !== passwordData.value.confirmNewPassword) {
      passwordError.value = '비밀번호가 일치하지 않습니다.';
      return;
    }
  }
};

// 주소 검색 관련 함수들
const loadDaumPostcodeScript = async (): Promise<void> => {
  if ((window as any).daum?.Postcode) return;
  if (daumScriptLoading) {
    await daumScriptLoading;
    return;
  }
  daumScriptLoading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Daum Postcode script load failed'));
    document.head.appendChild(script);
  });
  await daumScriptLoading;
};

const embedDaumPostcode = async () => {
  addressLoading.value = true;
  try {
    await loadDaumPostcodeScript();
    await nextTick();
    const container = postcodeContainer.value;
    if (!container) throw new Error('Container not ready');
    container.innerHTML = '';
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode is undefined');
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        userInfo.value.m_addr = selected || '';
        addressDialog.value = false;
        addressLoading.value = false;
      },
      onresize: (size: any) => {
        try {
          (container as HTMLDivElement).style.height = `${size.height}px`;
        } catch {}
      },
      width: '100%',
      height: '100%'
    });
    try {
      postcode.embed(container, { autoClose: true });
      addressLoading.value = false;
    } catch (e) {
      addressLoading.value = false;
      throw e;
    }
  } catch (e) {
    addressLoading.value = false;
    throw e;
  }
};

const openAddressModal = async () => {
  addressDialog.value = true;
};

watch(addressDialog, async (val) => {
  if (val) {
    try {
      await embedDaumPostcode();
    } catch (e) {
      addressDialog.value = false;
      store.commit('showSnackbar', { text: '주소 검색 로드에 실패했습니다.', color: 'error' });
    }
  }
});

// 뒤로가기
const goBack = () => {
  router.back();
};

// 비밀번호 변경 모달 열기
const openPasswordModal = () => {
  passwordData.value = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  };
  passwordError.value = '';
  passwordDialog.value = true;
};

// 비밀번호 변경 모달 닫기
const closePasswordModal = () => {
  passwordDialog.value = false;
  passwordData.value = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  };
  passwordError.value = '';
  showCurrentPassword.value = false;
  showNewPassword.value = false;
  showConfirmNewPassword.value = false;
};

// 비밀번호 변경
const changePassword = async () => {
  if (!isPasswordValid.value) return;
  
  passwordLoading.value = true;
  try {
    const response = await axios.put(`${API_BASE_URL}/auth/password`, {
      currentPassword: passwordData.value.currentPassword,
      newPassword: passwordData.value.newPassword
    }, {
      withCredentials: true,
      timeout: 10000
    });
    
    const result = response.data;
    
    if (result.success) {
      store.commit('showSnackbar', { text: '비밀번호가 성공적으로 변경되었습니다.', color: 'info' });
      closePasswordModal();
    } else {
      store.commit('showSnackbar', { text: result.message || '비밀번호 변경에 실패했습니다.', color: 'error' });
    }
  } catch (error: any) {
    console.error('비밀번호 변경 오류:', error);
    store.commit('showSnackbar', { 
      text: error.response?.data?.message || '비밀번호 변경 중 오류가 발생했습니다.', 
      color: 'error' 
    });
  } finally {
    passwordLoading.value = false;
  }
};

// 사용자 정보 수정
const updateUserInfo = async () => {
  if (!isFormValid.value) return;
  
  loading.value = true;
  loadingText.value = '정보를 수정하는 중...';
  try {
    const response = await axios.put(`${API_BASE_URL}/auth/account`, userInfo.value, {
      withCredentials: true,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    const result = response.data;
    if (result.success) {
      store.commit('setUser', userInfo.value);
      store.commit('showSnackbar', { text: '사용자 정보가 성공적으로 수정되었습니다.', color: 'info' });
    } else {
      store.commit('showSnackbar', { text: result.message || '사용자 정보 수정에 실패했습니다.', color: 'error' });
    }
  } catch (error: any) {
    console.error('사용자 정보 수정 오류:', error);
    store.commit('showSnackbar', { 
      text: error.response?.data?.message || '사용자 정보 수정 중 오류가 발생했습니다.', 
      color: 'error' 
    });
  } finally {
    loading.value = false;
  }
};

// 컴포넌트 마운트 시
onMounted(async () => {
  await store.dispatch('validateAuth');
  if (!store.getters.isLoggedIn) {
    router.push('/pwa/login');
    return;
  }
  
  const currentUser = store.getters.currentUser;
  if (currentUser) {
    userInfo.value = { ...currentUser };
  }
});
</script>

<style scoped lang="scss">
.pwa-userinfo {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding-bottom: 100px;
}

// 헤더
.pwa-header {
  background: #1e3a8a;
  padding: 16px 20px;
  padding-top: calc(16px + env(safe-area-inset-top, 0px));
  color: white;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: white;
  padding: 0;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin: 0;
  flex: 1;
  text-align: center;
  font-family: 'Noto Sans KR', sans-serif;
}

.header-spacer {
  width: 40px;
}

// 메인 컨텐츠
.pwa-content {
  padding: 20px 16px;
}

// 정보 섹션
.info-section {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
  font-family: 'Noto Sans KR', sans-serif;
}

.info-item {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.info-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  font-family: 'Noto Sans KR', sans-serif;

  .required {
    color: #dc2626;
  }
}

.info-input {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  font-size: 15px;
  color: #1f2937;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-sizing: border-box;
  transition: all 0.2s ease;
  font-family: 'Noto Sans KR', sans-serif;

  &:focus {
    outline: none;
    border-color: #1e3a8a;
    box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);
  }

  &:disabled {
    background: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
  }

  &[readonly] {
    background: #f9fafb;
    color: #1f2937;
    cursor: pointer;
  }

  &::placeholder {
    color: #9ca3af;
  }
}

.address-input-group {
  display: flex;
  gap: 8px;
  align-items: center;

  .info-input {
    flex: 1;
  }
}

.phone-input-group {
  display: flex;
  align-items: center;
  gap: 4px;
  
  .phone-input {
    flex: 1;
    text-align: center;
    min-width: 0;
  }
  
  .phone-separator {
    color: #6b7280;
    font-weight: 500;
    flex-shrink: 0;
  }
}

.address-btn {
  padding: 0 20px;
  height: 48px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background: #1e3a8a;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;

  &:active {
    background: #1e40af;
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

// 버튼 섹션
.button-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.save-btn {
  width: 100%;
  height: 52px;
  background: #1e3a8a;
  color: white;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans KR', sans-serif;

  &:active:not(:disabled) {
    background: #1e40af;
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.password-btn {
  width: 100%;
  height: 52px;
  background: #ffffff;
  color: #1e3a8a;
  font-size: 16px;
  font-weight: 600;
  border: 2px solid #1e3a8a;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans KR', sans-serif;

  &:active:not(:disabled) {
    background: #f9fafb;
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

// 모달
.modal-title {
  font-size: 18px;
  font-weight: 700;
  padding: 20px 24px;
  color: #1f2937;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
}

.modal-content {
  padding: 24px;
}

.modal-field {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.modal-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  font-family: 'Noto Sans KR', sans-serif;

  .required {
    color: #dc2626;
  }
}

.input-with-icon {
  position: relative;
  width: 100%;
}

.modal-input {
  width: 100%;
  height: 48px;
  padding: 0 48px 0 16px;
  font-size: 15px;
  color: #1f2937;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-sizing: border-box;
  transition: all 0.2s ease;
  font-family: 'Noto Sans KR', sans-serif;

  &:focus {
    outline: none;
    border-color: #1e3a8a;
    box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.1);
  }

  &:disabled {
    background: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #9ca3af;
  }
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  border-radius: 4px;

  &:active {
    background: #f3f4f6;
  }
}

.error-message {
  margin-top: 8px;
  font-size: 12px;
  color: #dc2626;
  font-weight: 500;
}

.modal-actions {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.cancel-btn {
  padding: 12px 24px;
  background: #ffffff;
  color: #374151;
  font-size: 15px;
  font-weight: 600;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Noto Sans KR', sans-serif;

  &:active:not(:disabled) {
    background: #f9fafb;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.confirm-btn {
  padding: 12px 24px;
  background: #1e3a8a;
  color: white;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Noto Sans KR', sans-serif;

  &:active:not(:disabled) {
    background: #1e40af;
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 10;
}

.loading-text {
  margin-top: 16px;
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}
</style>

